import * as z from 'zod';
import type { SignUpAliasCopy } from '@/i18n/sign-up-alias-copy';
import { isPlusAliasSignUpEmail } from './sign-up-email';

// Keep the existing password restriction (min length 6) as requested
export function createSignUpSchema(copy: SignUpAliasCopy) {
  return z
    .object({
      name: z
        .string()
        .min(2, 'Please enter your full name')
        .max(120, 'Name must be 120 characters or fewer'),
      email: z
        .string()
        .email('Please enter a valid email address')
        .refine((email) => !isPlusAliasSignUpEmail(email), {
          message: copy.plusAliasNotSupported,
        }),
      password: z.string().min(6, 'Password must be at least 6 characters'),
      confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
    });
}

export type SignUpFormType = z.infer<ReturnType<typeof createSignUpSchema>>;
